import React from 'react';
import { BarChart3, CheckSquare, Clock, FileText, Settings, User, Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

export interface EditRoleTabsListProps {
  usersCount: number;
  getTabPermissionCount: (tab: string) => number;
}

const permissionTabs = [
  { value: 'time-tracking', label: 'Time Tracking', icon: Clock },
  { value: 'approval', label: 'Approval', icon: CheckSquare },
  { value: 'reports', label: 'Reports & Analytics', icon: BarChart3 },
  { value: 'management', label: 'Management', icon: User },
  { value: 'data', label: 'Data & Integration', icon: FileText },
  { value: 'administration', label: 'Administration', icon: Settings },
];

export const EditRoleTabsList: React.FC<EditRoleTabsListProps> = ({ usersCount, getTabPermissionCount }) => (
  <div
    className="overflow-x-auto overscroll-x-contain"
    style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
  >
    <TabsList className="flex w-max min-w-full flex-nowrap justify-start lg:grid lg:w-full lg:grid-cols-8">
      <TabsTrigger value="details" className="gap-2">
        <User className="h-4 w-4" />
        Details
      </TabsTrigger>
      {permissionTabs.map(({ value, label, icon: Icon }) => {
        const count = getTabPermissionCount(value);
        return (
          <TabsTrigger key={value} value={value} className="gap-2">
            <Icon className="h-4 w-4" />
            {label}
            {count > 0 && (
              <Badge variant="secondary" className="ml-1 h-5 min-w-5 px-1.5 text-xs">{count}</Badge>
            )}
          </TabsTrigger>
        );
      })}
      <TabsTrigger value="users" className="gap-2">
        <Users className="h-4 w-4" />
        Users
        <Badge variant="secondary" className="ml-1 h-5 min-w-5 px-1.5 text-xs">{usersCount}</Badge>
      </TabsTrigger>
    </TabsList>
  </div>
);
